import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import ResultPage from './ResultPage';
import CulturePage from './CulturePage';

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-brand-primary">
      {/* 桌面端限制最大宽度800px居中；手机端自动全屏 */}
      <div className="mx-auto max-w-[800px] min-h-screen bg-brand-secondary shadow-[0_0_60px_rgba(0,0,0,0.5)]">
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/result/:constellationId" element={<ResultPage />} />
            <Route path="/culture" element={<CulturePage />} />
          </Routes>
        </Router>
      </div>
    </div>
  );
};

export default App;